import { ButtonProps } from '@slal/ui/buttons';
import { ComponentPropsWithoutRef } from 'react';
import { StyledButton, StyledButtonGroup } from './styles';

export const CardButton = (props: ButtonProps) => <StyledButton {...props} />;

export const CardButtonGroup = (props: ComponentPropsWithoutRef<'div'>) => <StyledButtonGroup {...props} />;
